import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setErrorEncrypt, setResetData } from '../redux/reducer/stepReducer/stepReducer';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Fade, Modal, Typography } from '@mui/material';
import { CODEMP_MUSIMUNDO } from '../utilities';

const customStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '287px',
    bgcolor: '#ECE6F0',
    borderRadius: '20px',
    p: '16px',
};

export const Timer = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [lastActivity, setLastActivity] = useState(Date.now());
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const { codemp } = useSelector(state => state.adminReducer.login);
    const { firstStep } = useSelector((state) => state.firstStep);

    const handleActivity = () => {
        setLastActivity(Date.now());
    };

    const handleCloseModal = async () => {
        setModalIsOpen(false);
        dispatch(setErrorEncrypt(true));
        navigate('/error');
    };

    const checkInactivity = () => {
        const currentTime = Date.now();
        const timeAllowed = 1800000; //30 min expresados en milisegundos
        // console.log(currentTime - lastActivity >= timeAllowed)
        if (currentTime - lastActivity >= timeAllowed) {
            localStorage.removeItem("codpmpol");
            localStorage.removeItem("response");
            localStorage.removeItem("date");
            localStorage.removeItem("firstStep");
            localStorage.removeItem("titularData");
            localStorage.removeItem("homeData");
            localStorage.removeItem("payMethod");
            localStorage.removeItem("url");
            localStorage.removeItem("test");
            localStorage.removeItem("plan");
            localStorage.removeItem("insured");
            localStorage.removeItem("productType");
            if (firstStep.codsec == '12') {
                localStorage.removeItem("typeBeneficiary");
                localStorage.removeItem("completedCheck");
                localStorage.removeItem("expanded");
                localStorage.removeItem("beneficiaryData");
                localStorage.removeItem("checkedItems");
            }
            setModalIsOpen(true);
        };
    };

    useEffect(() => {
        window.addEventListener('mousemove', handleActivity);
        window.addEventListener('keydown', handleActivity);
        window.addEventListener('scroll', handleActivity)
        const interval = setInterval(checkInactivity, 1000);

        return () => {
            window.removeEventListener('mousemove', handleActivity);
            window.removeEventListener('keydown', handleActivity);
            window.removeEventListener('scroll', handleActivity);
            clearInterval(interval);
        };
    }, [window, lastActivity]);


    return (
        <>
            <div>
                {children}
            </div>
            <Modal
                open={modalIsOpen}
                onClose={handleCloseModal}
                closeAfterTransition
            >
                <Fade in={modalIsOpen}>
                    <Box sx={customStyles}>
                        <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }}>
                            ¡Lo lamentamos!
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }} component="h3" style={{ fontFamily: 'Roboto', justifyContent: "center", alignItems: "center" }}>
                            La sesión expiró por tiempo de inactividad.
                        </Typography>
                        <div
                            className="contenedorBotones"
                            style={{
                                spacing: 9,
                                display: "flex",
                                flexDirection: "row",
                                margin: 13,
                                position: "relative",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <Button
                                style={{ borderRadius: 20, textTransform: "capitalize" }}
                                size="medium"
                                color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                                variant="contained"
                                type="submit"
                                onClick={handleCloseModal}
                            >
                                Aceptar
                            </Button>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </>
    )
};
